/** @jsxImportSource @emotion/react */

import { IconButton, TextField } from "@bonusx-global/bx-design-system";
import { SearchOutlined, TimesSolid } from "@bonusx-global/bx-icons";
import InputAdornment from "@mui/material/InputAdornment";
import type { ChangeEvent, FocusEvent, MouseEventHandler } from "react";
import { EMPTY_STRING, SEARCH_PLACEHOLDER } from "../../../../constants/commonStrings";

export interface SearchInputProps {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onClick?: MouseEventHandler<HTMLDivElement>;
  autoFocus?: boolean;
  resetInput?: () => void;
  value?: string;
}

export const SEARCH_INPUT_ID = "search-input";

export function SearchtInput({
  onChange,
  onFocus,
  onBlur,
  onClick,
  autoFocus,
  resetInput,
  value,
  onKeyDown,
}: Readonly<SearchInputProps>) {
  const showEndAdornment = value && value !== EMPTY_STRING;

  return (
    <TextField
      id={SEARCH_INPUT_ID}
      size="small"
      fullWidth
      value={value}
      onChange={onChange}
      placeholder={SEARCH_PLACEHOLDER}
      onFocus={onFocus}
      onClick={onClick}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined />
          </InputAdornment>
        ),
        endAdornment: showEndAdornment ? (
          <InputAdornment position="end">
            <IconButton size="medium" onClick={resetInput}>
              <TimesSolid />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
}
